












































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import axios from 'axios'
import { Cow } from '@/interfaces/Cow'
import { Dialog } from '@/interfaces/Dialog'
import TimeService from '@/services/time-service'
import CowService from '@/services/cow-service'
import DexieService from '@/services/dexie-service'
import SnackbarService from '@/services/snackbar-service'
import moment from 'moment'
import ApiService from '@/services/api-service'
import DatetimePicker from '@/components/DatetimePicker.vue'

@Component({
  components: {
    DatetimePicker,
  },
})
export default class AddView extends Mixins(
  TimeService,
  CowService,
  DexieService,
  SnackbarService,
  ApiService
) {
  @Prop({
    required: false,
    type: String,
  })
  motherNumber: string

  @Prop({
    required: false,
    type: Number,
  })
  motherId: number

  @Prop({
    required: true,
    type: Boolean,
  })
  addCowModalIsOpen: number

  cowIdsAndNumbers: any = []

  status = 'possession'

  cow: Cow | null = null

  cowNumbers: { text: string; value: string }[] | null = null

  defaultCow = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    number: '',
    race_id: this.$store.state.account.races.find(r => r.is_default)
      ? this.$store.state.account.races.find(r => r.is_default).id
      : null,
    color: '',
    iron_id: this.$store.state.account.irons.find(i => i.is_default)
      ? this.$store.state.account.irons.find(i => i.is_default).id
      : null,
    pregnancyDate: '',
    birthDate: '',
    observation: '',
    pregnantSince: 0,
    fertility: 'becerro',
    farm_id: this.$store.state.selectedFarmId,
    age: 0.01,
    female: true,
    gender: 'female',
    selected: false,
    // eslint-disable-next-line @typescript-eslint/camelcase
    mother_id: null,
    mother_number: null,
    status: 'possession',
  }

  cowNumberExistsError = false
  cowNumberExistsMessage = ''

  created() {
    this.init()
  }

  @Watch('addCowModalIsOpen')
  init() {
    if (this.addCowModalIsOpen) {
      this.cow = JSON.parse(JSON.stringify(this.defaultCow))
      this.cow.additional_cols = this.$store.state.account.col_defs.map(
        (colDef: any) => {
          return {
            type: colDef.type,
            col_def_id: colDef.id,
            name: colDef.name,
            options:
              colDef.type === 'select'
                ? this.$store.state.account.add_col_options
                    .filter(c => c.col_def_id === colDef.id)
                    .map(c => ({ text: c.value, value: c.id }))
                : null,
            value: '',
            value_id: null,
          }
        }
      )
      console.log('this.cow with additional cols', this.cow)
      if (this.motherId) {
        this.cow.mother_id = this.motherId
        this.cow.mother_number = this.motherNumber
      }
      this.getCowIdsAndNumbers()
    }
  }

  getCowIdsAndNumbers() {
    const cowIdsAndNumbers: { value: string; text: string }[] = [
      { value: null, text: 'Sin' },
    ]
    if (navigator.onLine) {
      axios
        .get(`/cow-ids-numbers`)
        .then(res => {
          res.data.forEach((c: any) => {
            cowIdsAndNumbers.push({ value: c.id, text: c.number })
          })
          this.cowIdsAndNumbers = cowIdsAndNumbers
          this.setNumberAutogenerated()
          this.setMotherValues()
        })
        .catch(error => {
          this.notify({ text: `Server error. ${error}` })
          this.$store.state.loading = false
        })
    } else {
      const cowIdsAndNumbers = []
      this.$db.cows.toArray().then((cows: Cow[]) => {
        cows.forEach((cow: Cow) => {
          cowIdsAndNumbers.push({ value: cow.id, text: cow.number })
        })
        this.cowIdsAndNumbers = cowIdsAndNumbers
        this.setNumberAutogenerated()
        this.setMotherValues()
      })
    }
  }

  setNumberAutogenerated() {
    // set number autogenerated of mother id
    if (this.motherNumber) {
      this.cow.number = `b_${this.motherNumber}_${this.generateId(5)}`
    }
  }

  setMotherValues() {
    // set id and number of mother
    const mother: any = this.cowIdsAndNumbers.find(
      (c: any) => c.number === this.motherNumber
    )
    if (mother) {
      this.cow.mother_id = mother.id
      this.cow.mother_number = mother.number
    }
  }

  changePregnancyDate(event: number) {
    this.cow!.pregnancyDate = this.getPregnancyDate(event)
  }

  changeBirthDate(event: number) {
    this.cow!.birthDate = this.getBirthDate(event)
  }

  changeFemale(event: number) {
    this.cow!.female = this.getFemale(event)
  }

  /**
   * @param isUpdate - function will be triggered from edit dialog
   *                   or from modus add cow
   */
  changeFertilityAndPregnancy() {
    // a male cow, can only have fertility macho
    const gender = this.cow.gender
    if (gender === 'male') {
      this.cow.fertility = 'macho'
      this.cow.pregnantSince = 0
      this.cow.pregnancyDate = ''

      // default for female cow
    } else {
      this.cow.fertility = 'becerro'
    }
  }

  changeGender() {
    this.cow.gender = this.cow.fertility === 'macho' ? 'male' : 'female'
    this.cow.female = this.cow.fertility === 'macho' ? false : true
  }

  inputNotValid() {
    return (
      this.cowNumberExistsError ||
      this.cow.number === '' ||
      this.cow.age === -1 ||
      this.cow.gender === '' ||
      this.cow.fertility === '' ||
      this.cow.pregnantSince === -1 ||
      !this.cow.farm_id ||
      this.cowTooYoungToBePregnant
    )
  }

  addCow() {
    this.$store.state.loading = true
    const cowToAdd: any = JSON.parse(JSON.stringify(this.cow))
    cowToAdd.birthDate = this.getBirthDate(this.cow.age)
    cowToAdd.female = this.getFemale(cowToAdd.gender)
    delete cowToAdd.age
    delete cowToAdd.pregnantSince
    delete cowToAdd.gender
    if (cowToAdd.pregnancyDate === '') {
      delete cowToAdd.pregnancyDate
    }
    const url = `/cows`
    const payload = cowToAdd
    if (navigator.onLine) {
      // delete options from additonal cols
      cowToAdd.additional_cols = cowToAdd.additional_cols.filter(
        (c: any) => c.value !== '' || c.value_id
      )
      cowToAdd.additional_cols.forEach((addCol: any) => {
        delete addCol.options
      })
      axios
        .post(url, payload)
        .then(() => {
          this.notify({ text: 'Agregado exitosamente', type: 'success' })
          this.$emit('close')
        })
        .catch(error => {
          this.notify({ text: `Server error. ${error}` })
        })
    } else {
      cowToAdd.account_id = this.$store.state.user.account_id
      cowToAdd.abortions = []
      cowToAdd.date_of_death = null
      cowToAdd.date_of_sell = null
      cowToAdd.additional_cols.forEach((col: any) => {
        col.col_def = this.$store.state.account.col_defs.find(
          (colDef: any) => colDef.id === col.col_def_id
        )
      })
      if (cowToAdd.mother_id) {
        cowToAdd.mother_number = this.cowIdsAndNumbers.find(
          (c: Cow) => c.value === cowToAdd.mother_id
        ).text
      } else {
        cowToAdd.mother_id = null
        cowToAdd.mother_number = null
      }
      this.$db.cows.add(cowToAdd).then((dexieId: any) => {
        console.log('cow id from dexie', dexieId)
        this.notify({ text: 'Agregado exitosamente', type: 'success' })
        this.$db.syncs.add({
          method: 'post',
          offlineAddedId: dexieId,
          farm_id: this.cow.farm_id,
          timestamp: new Date().toISOString(),
          number: this.cow.number,
          url,
          action: 'Vaca: Aggragar',
          message: 'Aggregar nueva vaca',
          payload,
        })
        this.$emit('close')
      })
    }
  }

  checkcowNumberExists() {
    console.log('check cow number exists', this.cowIdsAndNumbers)
    const cow = this.cowIdsAndNumbers.find(
      (c: Cow) => c.text === this.cow.number
    )
    if (cow) {
      this.cowNumberExistsError = true
      this.cowNumberExistsMessage = `Vaca con numero ${this.cow.number} ya existe`
    } else {
      this.cowNumberExistsError = false
      this.cowNumberExistsMessage = ''
    }
  }

  getOverdueMessage() {
    if (this.cow.pregnantSince > 7) {
      return `Preñez: ${this.cow.pregnantSince} meses. Fecha: ${this.cow.pregnancyDate}`
    } else {
      null
    }
  }

  get cowTooYoungToBePregnant() {
    return this.cow.age < 1 && this.cow.pregnantSince > 0
  }

  generateId(length: number) {
    let result = ''
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length))
    }
    return result
  }
}
